import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { any, isEmpty } from 'ramda'
import withNotifications from 'components/shared/notifications'
import { connectMarketo } from 'app/modules/integrations/api'
import CircleOfWaiting from 'components/shared/CircleOfWaiting'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import app from 'containers/app'
import { fetchIntegrationStates } from 'app/modules/integrations/actions'

import style from './style.styl'

const CONNECT_ERROR_MESSAGE = 'Oops, there was an error connecting to Marketo. Are your credentials correct? Please try again.'
const CONNECT_SUCCESS_MESSAGE = 'Marketo was successfully connected!'
const STATUS_PAGE_URL = '/settings/setup/marketo'

const InputGroup = ({ title, description, setValue }) => (
  <div className="marketo-config-input-group drift-form">
    <span className="marketo-config-input-group-title">
      {title}
    </span>
    <input type="text" onChange={setValue} />
    <div className="marketo-config-input-group-description">
      {description}
    </div>
  </div>
)

class MarketoConfigPage extends Component {

  constructor(props) {
    super(props)
    this.state = {
      munchkinId: '',
      clientId: '',
      clientSecret: '',
      isConnecting: false
    }
  }

  static contextTypes = {
    router: PropTypes.object.isRequired
  }

  setMunchkinId = (event) => {
    this.setState({
      munchkinId: event.target.value,
    })
  }

  setClientId = (event) => {
    this.setState({
      clientId: event.target.value,
    })
  }

  setClientSecret = (event) => {
    this.setState({
      clientSecret: event.target.value,
    })
  }

  isConnectDisabled = () => {
    const { munchkinId, clientId, clientSecret } = this.state
    return any(isEmpty)([munchkinId, clientId, clientSecret])
  }

  connectMarketo = () => {
    const { munchkinId, clientId, clientSecret } = this.state
    const { router } = this.context

    const onSuccess = () => {
      this.setState({ isConnecting: false })
      this.props.notifications.success(CONNECT_SUCCESS_MESSAGE)
      router.push({ pathname: STATUS_PAGE_URL, query: { expanded: true }})
    }

    const onError = () => {
      this.setState({ isConnecting: false })
      this.props.notifications.error(CONNECT_ERROR_MESSAGE)
    }

    this.setState({ isConnecting: true })

    connectMarketo({ munchkinId, clientId, clientSecret })
      .then(() => this.props.actions.fetchIntegrationStates())
      .then(onSuccess)
      .catch(onError)
  }

  render() {
    const { isConnecting } = this.state

    return (
      <div className="marketo-config-page">

        <div className="marketo-config-page-header">
          <h1 className="marketo-config-page-title">
            Connect Drift and Marketo V2
          </h1>
          <p className="marketo-config-page-description">
            Connect your Drift to Marketo V2 integration here. Need some help?
            Feel free to talk to us or view our
            <a href="https://gethelp.drift.com/hc/en-us/sections/360003545713-Marketo-and-Drift" target="_blank">Setup Guide</a>.
          </p>
        </div>

        <div className="marketo-config-input-groups">
          <InputGroup
            title="Munchkin Account ID"
            description={
              <p className="munchkin-account-id-description">
                You can find your Account ID under
                <span>Admin &gt; Integration &gt; Munchkin &gt; Tracking Code</span>
                in your
                <a href="https://gethelp.drift.com/hc/en-us/articles/360019503974-How-to-Connect-Drift-and-Marketo" target="_blank">
                  Marketo Account
                </a>
              </p>
            }
            setValue={this.setMunchkinId}
          />
          <InputGroup
            title="Client ID"
            description="This is your Marketo REST API Client ID"
            setValue={this.setClientId}
          />
          <InputGroup
            title="Client Secret"
            description="This is your Marketo REST API Client Secret"
            setValue={this.setClientSecret}
          />
        </div>

        <button
          onClick={this.connectMarketo}
          className="marketo-config-connect-button drift-button drift-button-primary"
          disabled={this.isConnectDisabled()}>
          {isConnecting &&
            <CircleOfWaiting />
          }
          {!isConnecting &&
            <span>Connect Marketo V2</span>
          }
        </button>

      </div>
    )
  }
}

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators({ fetchIntegrationStates }, dispatch)
})

export default connect(null, mapDispatchToProps)(
  withNotifications(MarketoConfigPage)
)



// WEBPACK FOOTER //
// ./src/scripts/components/Integration/pages/MarketoConfigPage/index.js